module.exports = __webpack_public_path__ + "img/close-info.8c9813fb.svg";